// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BarDistributionCard_footer__odsFE {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: var(--dylo-muted);
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/BarDistributionCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".footer {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--dylo-muted);\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `BarDistributionCard_footer__odsFE`
};
export default ___CSS_LOADER_EXPORT___;
